import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { tap } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import { SpinnerService } from '../../shared/services/spinner.service';
import { OpenSearchService } from '../../shared/services/open-search.service';
import { SKIP_SPINNER } from './spinner-context.token';

@Injectable({
  providedIn: 'root',
})
export class SpinnerInterceptor implements HttpInterceptor {
  private spinnerService = inject(SpinnerService);
  OpenSearchService = inject(OpenSearchService);
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.OpenSearchService.spinnerConversational() || req.context.get(SKIP_SPINNER)) {
      return next.handle(req);
    }
    this.spinnerService.show();
    return next.handle(req).pipe(
      tap(() => {
        localStorage.removeItem('hiddenTemporalOnboarding');
      }),
      finalize(() => {
        this.spinnerService.hide();
      }),
      catchError((error: any) => {
        throw error;
      }),
    );
  }
}
